import { types } from 'mobx-state-tree';

const CustomNavigationLink = types.model('CustomNavigationLink', {
  id: types.identifierNumber,
  link_type: types.string,
  link: types.string,
  name: types.string,
  parent_sibling_id: types.maybeNull(types.number),
  tree_type: types.string,
  location: types.string
});

export default CustomNavigationLink;



// WEBPACK FOOTER //
// ./src/models/CustomNavigationLink.js